<div
  class="filter-container"
  [class.allow-drag-and-drop]="allowDragAndDrop"
  [dndDraggable]="filter"
	dndEffectAllowed="move"
	(dndStart)="onDragStart(filter)"
  (dndEnd)="onDragEnd()"
  dndDraggingClass="dragging"
  [dndDisableIf]="!allowDragAndDrop">
  <div class="header" dndHandle>
    <div class="filter-name" *ngIf="filterAsEncFilterField.formula">
      <capra-icon
        *ngIf="tooManySelected"
        icon="icon-warning"
        [tooltipContent]="tooManySelectionsTooltip"
        [tooltipDelay]="250"
        [tooltipInteractive]="true"
        tooltipPlacement="left"
        capraTooltip
        class="filter-warning"
      ></capra-icon>
      <capra-icon
        *ngIf="isOrphan"
        icon="icon-warning"
        [tooltipContent]="orphanedFilterTooltip"
        [tooltipDelay]="250"
        [tooltipInteractive]="true"
        tooltipPlacement="left"
        class="filter-error"
        capraTooltip
      ></capra-icon>
      <capra-icon
        *ngIf="isRelevantValue && !hasWarning"
        icon="icon-relevant-values"
        [tooltipContent]="relevantValueTooltip"
        [tooltipDelay]="250"
        [tooltipInteractive]="true"
        tooltipPlacement="left"
        capraTooltip
      ></capra-icon>
      <div class="filter-title">{{ filter.name }}</div>
    </div>
    <div class="header-cta-container">
      <capra-icon-button
        *ngIf="showSettingsMenu"
        class="settings-menu-cta"
        aria-label="Expand filter menu"
        icon="icon-gear"
        [matMenuTriggerFor]="filterContainerMenu"
      >
      </capra-icon-button>
    </div>
  </div>

  <mat-menu #filterContainerMenu="matMenu" class="filter-container-menu">
    <div>
      <button mat-menu-item (click)="onReportFilterTypeClick('SINGLE')" [class.selected]="isSingle">
        <span>Single-select</span>
      </button>
      <button mat-menu-item (click)="onReportFilterTypeClick('MULTI')" [class.selected]="isMulti">
        <span>Multi-select</span>
      </button>
    </div>
    <mat-divider></mat-divider>
    <div>
      <button mat-menu-item (click)="setDiscreteControlType('list')" [class.selected]="!isDropdown" *ngIf="showDropdownToggle && !isRange">
        <span>List</span>
      </button>
      <button mat-menu-item (click)="setDiscreteControlType('dropdown')" [class.selected]="isDropdown" *ngIf="showDropdownToggle && !isRange">
        <span>Dropdown menu</span>
      </button>
      <button mat-menu-item *ngIf="isShowingRangeOption" (click)="onReportFilterTypeClick('RANGE')" [class.selected]="isRange">
        <span>Range field</span>
      </button>
    </div>
    <mat-divider></mat-divider>
    <div *ngIf="isSingle || isMulti">
      <button mat-menu-item (click)="onShowAllClick()" [class.all-selected]="isShowingAll" >
        <capra-icon icon="icon-check" *ngIf="isShowingAll"></capra-icon>
        <span>Show "All" in the list</span>
      </button>
      <mat-divider></mat-divider>
    </div>
    <div *ngIf="showRelevantValueOption">
      <button mat-menu-item (click)="onShowRelevantValues()" [class.all-selected]="isRelevantValue">
        <capra-icon icon="icon-check" *ngIf="isRelevantValue"></capra-icon>
        <span>Only display relevant values</span>
      </button>
      <mat-divider></mat-divider>
    </div>
    <div>
      <button mat-menu-item (click)="onMoveUpClick()">
        <span>Move up</span>
      </button>
      <button mat-menu-item (click)="onMoveDownClick()">
        <span>Move down</span>
      </button>
      <button mat-menu-item (click)="onMoveToTopClick()">
        <span>Move to top</span>
      </button>
      <button mat-menu-item (click)="onMoveToBottomClick()">
        <span>Move to bottom</span>
      </button>
    </div>
    <mat-divider></mat-divider>
    <div>
      <button mat-menu-item (click)="onResetFilterClick()">
        <span>Reset filter</span>
      </button>
    </div>
    <mat-divider></mat-divider>
    <div>
      <button mat-menu-item (click)="onDeleteFilterClick()">
        <span>Delete</span>
      </button>
    </div>
  </mat-menu>

  <mode-date-range
    *ngIf="isRange && filterAsEncFilterField.filterType === 'CONTINUOUS_DATE'"
    [filter]="filterAsEncFilterField"
    [dataMinTimestamp]="rangeFilterOption?.values?.min || null"
    [dataMaxTimestamp]="rangeFilterOption?.values?.max || null"
    [isLoading]="false"
    (filterChange)="onRangeFilterChange($event)"
  ></mode-date-range>

  <mode-numeric-range
    *ngIf="isRange && filterAsEncFilterField.filterType === 'CONTINUOUS'"
    [filter]="filterAsEncFilterField"
    [dataMin]="rangeFilterOption?.values?.min"
    [dataMax]="rangeFilterOption?.values?.max"
    [isLoading]="false"
    (filterChange)="onRangeFilterChange($event)"
  ></mode-numeric-range>

  <mode-multi-select
    *ngIf="isMulti && !isDropdown"
    [showAll]="!filter.hideSelectAll"
    [filter]="filterAsEncFilterField"
    [filterOption]="filterOptionsAsDomainResults"
    [isLoading]="false"
    (filterChange)="onMultiSelectFilterChange($event.filter, $event.selectedValue, $event.isChecked, $event.searchTerm)"
  ></mode-multi-select>

  <mode-single-select
    *ngIf="isSingle && !isDropdown"
    [showAll]="!filter.hideSelectAll"
    [filter]="filterAsEncFilterField"
    [filterOption]="filterOptionsAsDomainResults"
    [isLoading]="false"
    (filterChange)="onSelectFilterChange($event)"
  ></mode-single-select>

  <mode-dropdown-filter
    *ngIf="isDropdown"
    [showAll]="!filter.hideSelectAll"
    [filter]="filterAsEncFilterField"
    [filterOption]="filterOptionsAsDomainResults"
    [isLoading]="false"
    [isMulti]="isMulti"
    [isSingle]="isSingle"
    (multiSelectChange)="onMultiSelectFilterChange($event.filter, $event.selectedValue, $event.isChecked, $event.searchTerm)"
    (singleSelectChange)="onSelectFilterChange($event)"
  ></mode-dropdown-filter>

  <div class="divider"></div>
</div>
